export default "__VITE_ASSET__CBf7z7xC__"